'use client';

import { ChevronUp } from 'lucide-react';
import { useEffect, useState } from 'react';

import { cn } from '@/utilities/cn';

const BackToTopBtn = () => {
  const [windowHeight, setWindowHeight] = useState<number>(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setWindowHeight(scrollPosition);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const onClick = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'w-12 h-12 z-50 bg-white/60 block rounded-full border-solid shadow-xl cursor-pointer p-3',
        'flex items-center justify-center box-border',
        'transition-all duration-300 ease-in-out hover:bg-white',
        windowHeight > 100 ? 'opacity-100' : 'opacity-0',
      )}
      aria-label='Back to top'
    >
      <ChevronUp />
    </button>
  );
};

export default BackToTopBtn;
